"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const ellipseshorizontal = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-ellipseshorizontal` : '') + (description ? ` desc-ellipseshorizontal` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-ellipseshorizontal"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-ellipseshorizontal"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.25 8.75C5.04493 8.75 6.5 10.2051 6.5 12C6.5 13.7949 5.04493 15.25 3.25 15.25C1.45507 15.25 0 13.7949 0 12C0 10.2051 1.45507 8.75 3.25 8.75ZM12 8.75C13.7949 8.75 15.25 10.2051 15.25 12C15.25 13.7949 13.7949 15.25 12 15.25C10.2051 15.25 8.75 13.7949 8.75 12C8.75 10.2051 10.2051 8.75 12 8.75ZM20.75 8.75C22.5449 8.75 24 10.2051 24 12C24 13.7949 22.5449 15.25 20.75 15.25C18.9551 15.25 17.5 13.7949 17.5 12C17.5 10.2051 18.9551 8.75 20.75 8.75Z",
    fill: "inherit"
  }));
};
var _default = exports.default = ellipseshorizontal;